import { Loader2Icon } from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { CircleCheckBold, CircleAlertBold } from "@/components/icons";

/**
 * Toast 아이콘 컴포넌트
 * - Positive (성공): 녹색 CircleCheckBold (#1AC100)
 * - Alert (경고): 주황색 CircleAlertBold (#FA811E)
 * - Urgent (에러): 빨간색 CircleAlertBold (#F30000)
 */
const ToastSuccessIcon = () => (
  <CircleCheckBold size={20} color="status-positive" />
);

const ToastWarningIcon = () => (
  <CircleAlertBold size={20} color="status-caution" />
);

const ToastErrorIcon = () => (
  <CircleAlertBold size={20} color="status-urgent" />
);

const ToastInfoIcon = () => (
  <CircleAlertBold size={20} color="status-available" />
);

const ToastLoadingIcon = () => (
  <Loader2Icon className="size-6 animate-spin text-static-white" />
);

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      position="top-center"
      icons={{
        // NOTI ! : 실제로는 success, error, warning 이렇게만 사용할 듯 함... 26.01.26
        success: <ToastSuccessIcon />,
        info: <ToastInfoIcon />,
        warning: <ToastWarningIcon />,
        error: <ToastErrorIcon />,
        loading: <ToastLoadingIcon />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast typo-body-2-medium group-[.toaster]:bg-labels-secondary group-[.toaster]:text-static-white group-[.toaster]:border-none group-[.toaster]:shadow-none group-[.toaster]:rounded-lg group-[.toaster]:px-4 group-[.toaster]:py-3 group-[.toaster]:gap-2 group-[.toaster]:max-w-[360px]",
          title:
            "group-[.toast]:typo-body-2-medium group-[.toast]:text-static-white",
          description:
            "group-[.toast]:typo-caption-1-medium group-[.toast]:text-static-white/70",
          actionButton:
            "group-[.toast]:bg-primary-normal group-[.toast]:text-static-white",
          cancelButton:
            "group-[.toast]:bg-fills-neutral group-[.toast]:text-labels-primary",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
